export default __webpack_public_path__ + "static/i-MedicalCard Elite_Shariah Concepts-20406146a7faf13c1ae77207be50e510.pdf";